@import "~@govbr-ds/core/src/components/card/card";

:host {
  display: block;
}
